import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\MessagesController::index
* @see app/Http/Controllers/Admin/MessagesController.php:27
* @route '/admin/messages'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/messages',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\MessagesController::index
* @see app/Http/Controllers/Admin/MessagesController.php:27
* @route '/admin/messages'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\MessagesController::index
* @see app/Http/Controllers/Admin/MessagesController.php:27
* @route '/admin/messages'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MessagesController::index
* @see app/Http/Controllers/Admin/MessagesController.php:27
* @route '/admin/messages'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\MessagesController::index
* @see app/Http/Controllers/Admin/MessagesController.php:27
* @route '/admin/messages'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MessagesController::index
* @see app/Http/Controllers/Admin/MessagesController.php:27
* @route '/admin/messages'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MessagesController::index
* @see app/Http/Controllers/Admin/MessagesController.php:27
* @route '/admin/messages'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\MessagesController::create
* @see app/Http/Controllers/Admin/MessagesController.php:77
* @route '/admin/messages/send'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/admin/messages/send',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\MessagesController::create
* @see app/Http/Controllers/Admin/MessagesController.php:77
* @route '/admin/messages/send'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\MessagesController::create
* @see app/Http/Controllers/Admin/MessagesController.php:77
* @route '/admin/messages/send'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MessagesController::create
* @see app/Http/Controllers/Admin/MessagesController.php:77
* @route '/admin/messages/send'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\MessagesController::create
* @see app/Http/Controllers/Admin/MessagesController.php:77
* @route '/admin/messages/send'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MessagesController::create
* @see app/Http/Controllers/Admin/MessagesController.php:77
* @route '/admin/messages/send'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MessagesController::create
* @see app/Http/Controllers/Admin/MessagesController.php:77
* @route '/admin/messages/send'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Admin\MessagesController::store
* @see app/Http/Controllers/Admin/MessagesController.php:98
* @route '/admin/messages/send'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/admin/messages/send',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\MessagesController::store
* @see app/Http/Controllers/Admin/MessagesController.php:98
* @route '/admin/messages/send'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\MessagesController::store
* @see app/Http/Controllers/Admin/MessagesController.php:98
* @route '/admin/messages/send'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\MessagesController::store
* @see app/Http/Controllers/Admin/MessagesController.php:98
* @route '/admin/messages/send'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\MessagesController::store
* @see app/Http/Controllers/Admin/MessagesController.php:98
* @route '/admin/messages/send'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\MessagesController::show
* @see app/Http/Controllers/Admin/MessagesController.php:180
* @route '/admin/messages/{message}'
*/
export const show = (args: { message: string | number } | [message: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/admin/messages/{message}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\MessagesController::show
* @see app/Http/Controllers/Admin/MessagesController.php:180
* @route '/admin/messages/{message}'
*/
show.url = (args: { message: string | number } | [message: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { message: args }
    }

    if (Array.isArray(args)) {
        args = {
            message: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        message: args.message,
    }

    return show.definition.url
            .replace('{message}', parsedArgs.message.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\MessagesController::show
* @see app/Http/Controllers/Admin/MessagesController.php:180
* @route '/admin/messages/{message}'
*/
show.get = (args: { message: string | number } | [message: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MessagesController::show
* @see app/Http/Controllers/Admin/MessagesController.php:180
* @route '/admin/messages/{message}'
*/
show.head = (args: { message: string | number } | [message: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\MessagesController::show
* @see app/Http/Controllers/Admin/MessagesController.php:180
* @route '/admin/messages/{message}'
*/
const showForm = (args: { message: string | number } | [message: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MessagesController::show
* @see app/Http/Controllers/Admin/MessagesController.php:180
* @route '/admin/messages/{message}'
*/
showForm.get = (args: { message: string | number } | [message: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\MessagesController::show
* @see app/Http/Controllers/Admin/MessagesController.php:180
* @route '/admin/messages/{message}'
*/
showForm.head = (args: { message: string | number } | [message: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

const messages = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    show: Object.assign(show, show),
}

export default messages